// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"009dd7f9","529":"231954e6"}[chunkId] + ".chunk.js";
};